module.exports = __webpack_public_path__ + "static/image_5_thumb-3e582403043701a765395ab59333a16b.jpg";